import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions/OrderActions'

class OrderDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            status: ''
        }
    }

    componentDidMount() {
        var { match } = this.props;
        var id = match.params.id;
        this.props.getOrderDetail(id)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.order) {
            this.setState({
                status: nextProps.order.status
            })
        }
    }

    format_curency = ((money) => {
        money = (money + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return money + "₫";
    });

    showProductOrder = (products) => {
        if (products) {
            return products.map((item, index) => {
                var category = "";
                switch (item.category) {
                    case 'ao-khoac':
                        category = "Áo khoác";
                        break;
                    case 'ao':
                        category = "Áo";
                        break;
                    case 'quan':
                        category = "Quần";
                        break;
                    case 'vay-dam':
                        category = "Váy đầm";
                        break;
                    case 'bo-mac-nha':
                        category = "Bộ mặc nhà";
                        break;
                    case 'giay':
                        category = "Giày";
                        break;
                    case 'tui-xach':
                        category = "Túi xách";
                        break;
                    default:
                        category = "Sản phẩm"
                        break;
                }
                return (
                    <tr key={index}>
                        <th style={{ border: "1px solid #000" }}>{item.name}</th>
                        <th style={{ border: "1px solid #000" }}>{category}</th>
                        <th style={{ border: "1px solid #000" }}>{this.format_curency(item.price)}</th>
                        <th style={{ border: "1px solid #000" }}>{(item.quantity)}</th>
                    </tr>
                )
            })
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        var { order } = this.props;
        var { status } = this.state;
        this.props.changeStatusOrder({
            id: order.id,
            nameUser: order.nameUser,
            addressUser: order.addressUser,
            phoneUser: order.phoneUser,
            totalPrice: order.totalPrice,
            date: order.date,
            note: order.note,
            status: status,
            listOrder: order.listOrder
        });
        this.props.history.push("/orders")
    }

    render() {
        var { order } = this.props;
        var { status } = this.state;
        return (
            <div className="oder__detail--page pt-5 pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="account__page--title">Thông tin đặt hàng</h3>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <h3 className="order__page--title mb-3">Thông tin người nhận</h3>
                            <p className="mb-3">Họ tên: <span>{order.nameUser}</span> </p>
                            <p className="mb-3">Địa chỉ nhận hàng: <span>{order.addressUser}</span> </p>
                            <p className="mb-3">Số điện thoại: <span>{order.phoneUser}</span> </p>
                        </div>
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <h3 className="order__page--title mb-3">Thông tin đặt hàng</h3>
                            <table className="table order-table" style={{ border: "1px solid #e1e1e1" }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: "1px solid #000" }}>Tên Sản phẩm</th>
                                        <th style={{ border: "1px solid #000" }}>Loại Sản phẩm</th>
                                        <th style={{ border: "1px solid #000" }}>Giá tiền</th>
                                        <th style={{ border: "1px solid #000" }}>Số lượng</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.showProductOrder(order.listOrder)}
                                </tbody>
                            </table>
                            <h3 className="product__item--detail-name">
                                Tổng tiền:
                                <span>
                                    {this.format_curency(order.totalPrice)}
                                </span>
                            </h3>
                            <div className="form-group d-flex align-items-center mt-3 mb-3" style={{ width: '250px' }}>
                                <label htmlFor="contactForm1" className="mr-5">
                                    Status
                                </label>
                                <select
                                    id="inputState"
                                    className="form-control"
                                    name="status"
                                    value={status}
                                    onChange={(e) => {
                                        this.setState({
                                            status: e.target.value
                                        })
                                    }}
                                >
                                    <option defaultValue="Đang chờ" value="Đang chờ">Đang chờ</option>
                                    <option value="Đang giao hàng">Đang giao hàng</option>
                                    <option value="Đã chốt">Đã chốt</option>
                                </select>
                            </div>
                            <h3 className="product__item--detail-name mt-3">
                                <button
                                    className="btn btn-outline-success"
                                    onClick={this.handleSubmit}
                                >Submit</button>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        order: state.orders.orderDetail
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getOrderDetail: (id) => {
            dispatch(actions.fetchAPIOrderDetail(id))
        },
        changeStatusOrder: (order) => {
            dispatch(actions.fetchAPIChangeStatusOrder(order))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);
